<template>
    <div>
        <page-title>编辑版本信息</page-title>
        <page-body>
            <el-form v-loading="loading" :model="form" :rules="rules" ref="form">
                <el-form-item label="应用" prop="app_id">
                    <el-select v-model="form.app_id" style="width: 100%;"
                               placeholder="请选择应用">
                        <el-option v-for="item in apps" :key="item.id" :label="item.display_name"
                                   :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="版本号" prop="version">
                    <el-input v-model="form.version" placeholder=""/>
                </el-form-item>
                <el-form-item label="更新代码包" prop="src_file">
                    <app-upload v-model="form.src_file"
                                v-on:on-success="onSrcUploadSuccess"></app-upload>
                </el-form-item>
                <el-form-item label="最小平台版本" prop="platform_version">
                    <el-input v-model="form.platform_version" placeholder=""/>
                </el-form-item>
                <el-form-item>
                    <el-button :loading="btnLoading" @click="submit('form')" type="primary">{{form.id ? '保存' : '发布'}}
                    </el-button>
                </el-form-item>
            </el-form>
        </page-body>
    </div>
</template>

<script>
import axios from '@/axios'
import baseUrl from '@/base-url'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import {quillEditor} from 'vue-quill-editor'
import {quillRedefine} from 'vue-quill-editor-upload'

export default {
    components: {
        quillEditor
    },
    data() {
        const validateVersion = (rule, value, callback) => {
            if (!this.packageVersion || !value) {
                return callback()
            }
            if (this.packageVersion !== value) {
                return callback(new Error('版本号与代码包版本不符合，代码包版本号' + this.packageVersion))
            }
            return callback()
        }
        return {
            uploadServer: baseUrl + '/admin/upload/file',
            uploadHeaders: null,
            loading: false,
            btnLoading: false,
            detail: null,
            uploadingSrcFile: false,
            uploadingDbFile: false,
            packageVersion: null,
            rules: {
                app_id: [
                    {required: true, message: '请选择应用。'}
                ],
                version: [
                    {required: true, message: '填写版本号。'},
                    {validator: validateVersion}
                ],
                src_file: [
                    {required: true, message: '填上传更新代码包。'}
                ],
                platform_version: [
                    {required: true, message: '填写平台最小版本号。'}
                ]
            },
            form: {
                id: null,
                app_id: null,
                version: '',
                src_file: '',
                platform_version: ''
            },
            editorOption: {},
            apps: []
        }
    },
    created() {
        this.editorOption = quillRedefine(
            {
                // 图片上传的设置
                uploadConfig: {
                    // 必填参数 图片上传地址
                    action: baseUrl + '/admin/upload/file',
                    header: (xhr, formData) => {
                        xhr.setRequestHeader('Access-Token', this.$store.state.user.access_token)
                    },
                    name: 'file',
                    // 必选参数  res是一个函数，函数接收的response为上传成功时服务器返回的数据
                    // 你必须把返回的数据中所包含的图片地址 return 回去
                    res: (response) => {
                        // 这里切记要return回你的图片地址
                        if (response.code === 0) {
                            return response.data.url
                        }
                    }
                }
            }
        )
        this.uploadHeaders = {
            'Access-Token': this.$store.state.user.access_token
        }
        if (this.$route.query.id) {
            this.form.id = this.$route.query.id
            this.loadData()
        }
        this.searchApps()
    },
    methods: {
        loadData() {
            this.loading = true
            axios({
                url: 'admin/app-version/detail',
                params: {
                    id: this.form.id
                }
            }).then(e => {
                this.loading = false
                if (e.data.code === 0) {
                    this.form = e.data.data
                } else {
                    this.$message.error(e.data.msg)
                }
            })
        },
        onSrcUploadSuccess(response) {
            this.packageVersion = response.data.validate.version
        },
        submit(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    this.btnLoading = true
                    axios({
                        url: 'admin/app-version/edit',
                        method: 'post',
                        data: this.form
                    }).then(e => {
                        this.btnLoading = false
                        if (e.data.code === 0) {
                            this.$message.success('保存成功。')
                            this.$router.push('/dashboard/admin/app-version/index')
                        } else {
                            this.$message.error(e.data.msg)
                        }
                    })
                }
            })
        },
        searchApps() {
            axios({
                url: 'admin/app/index'
            }).then(e => {
                if (e.data.code === 0) {
                    this.apps = e.data.data.list
                } else {
                    this.apps = []
                }
            }).catch(e => {
                this.apps = []
            })
        }
    }
}
</script>
